import React, { useEffect, useState } from 'react'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import { StudentApi } from '../../../api/student/student.api'
import { Box, Typography } from '@mui/material'
import { timeToView } from '../../../utils/date.utils'
import StateComponents from '../../../components/state-component/StateComponents'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import ContainerButton from '../../../components/button/ContainerButton'
import { ButtonBack } from '../../../components/button/ButtonCustoms'

export default function TermFeesDetail() {
    const { id, id_student_term_payment } = useParams()
    const navigate: NavigateFunction = useNavigate();

    const [detail, setDeatil] = useState<any>()
    const [pathUrl, setPathUrl] = useState<string>("");

    const getDetail = async () => {
        await StudentApi.get_student_term_payment_detail(Number(id), Number(id_student_term_payment)).then((res) => {
            if (res.status < 300) {
                setDeatil(res.data?.data);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        if (id) {
            getDetail()
        }
    }, [])
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);
    return (
        <div className='w-full'>
            <ContainerLayout
                title={`รายละเอียดการชำระค่าเทอม`}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: "ข้อมูลทะเบียนนักศึกษา",
                                disabled_match: true,
                                pathName: routeName.admission.student_registration_information
                            },

                            {
                                key: "complaintSubmit",
                                name: "ข้อมูลส่วนบุคคลนักศึกษา",
                                pathName: routeName.admission.student_registration_information_detail.replace(':id', `${id}`)
                            },
                            {
                                key: "complaintSubmit",
                                name: `รายละเอียดการชำระค่าเทอม`,
                                pathName: routeName.admission.student_registration_information_term_fees.replace(':id', `${id}`).replace(':id_student_term_payment', `${id_student_term_payment}`)
                            },
                        ]}
                    />
                }
                buttonContent={
                    // <ContainerButton
                    //     sxContainer={{ my: 3 }}
                    //     buttonData={[
                    //         {
                    //             seq: 1,
                    //             buttonProps: {
                    //                 onClick: () => { navigate(-1) },
                    //             },
                    //             key: "CANCEL",
                    //             label: "ย้อนกลับ",
                    //             type: "CANCEL"
                    //         },


                    //     ]}
                    // />
                    <ButtonBack buttonName='ย้อนกลับ' onClick={() => {
                        navigate(-1)
                    }}/>
                }
                content={
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                        {/* <Box sx={{
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "20px",
                            borderRadius: "20px",
                            display: "flex",
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            <Box sx={{
                                display: 'flex', alignItems: 'center', gap: "10px"
                            }}>
                                <Typography sx={{ color: '#737373' }}>ชื่อบัญชี <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_name_th}</span></Typography>
                                <Typography sx={{ color: '#737373' }}>Account Name <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_name_eng}</span></Typography>
                                <Typography sx={{ color: '#737373' }}>เลขที่บัญชี Account No. <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_no}</span></Typography>
                                <Typography sx={{ color: '#737373' }}>Account Type <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_type}</span></Typography>
                            </Box>
                            <Box sx={{ background: '#4A4A4A', padding: '10px', display: 'flex', alignItems: 'center', gap: "10px", borderRadius: '18px' }}>
                                <Typography sx={{ color: '#fff' }}>Currency</Typography>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[

                                        {
                                            seq: 1,
                                            type: "SELECT",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                labelId: "ss",
                                                // heading: "สกุลเงิน",
                                                onChange: (e) => {
                                                    setType(e.target.value)
                                                    // handleChange('form_type', index, e.target.value);
                                                },
                                                options: [
                                                    {
                                                        label: "THB",
                                                        value: 'THB',
                                                    },
                                                    {
                                                        label: "USD",
                                                        value: 'USD',
                                                    },
                                                ],
                                                selectId: "",
                                                value: type || ''
                                            }
                                        },


                                    ]} />
                                <Typography sx={{ color: '#fff' }}>Bachelor of arts degree : Application fee {type === 'THB' ? `${form?.course_of_study?.price_bath} Thai Baht (THB)` : `${form?.course_of_study?.price_usd} United States dollar (USD)`}</Typography>
                            </Box>
                            <Box sx={{
                                // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                // padding: "40px",
                                // borderRadius: "20px",
                                display: "flex",
                                flexDirection: 'column',
                                gap: '10px'
                            }}>
                                <Typography sx={{ fontWeight: "600" }}>รหัสประจำตัวนักศึกษา: {form?.student?.student_no}</Typography>
                                <Typography sx={{ fontWeight: "600" }}>ลิงก์ชำระเงิน: <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => window.open(form?.url_payment_term, '_blank')}>{form?.url_payment_term}</span></Typography>

                            </Box>
                        </Box> */}
                        <Box sx={{
                            // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "10px",
                            borderRadius: "20px",
                            height: "500px",
                            display: "flex",
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#F6F6F6'
                        }}>
                            <img src={pathUrl + '/' + detail?.file_path + detail?.file_name} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} />
                        </Box>
                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "DATE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onChange: (e) => { },
                                        heading: 'วันที่ชำระเงิน',
                                        placeholder: 'วันที่ชำระเงิน',
                                        allowClear: true,
                                        onClear: () => {

                                        },
                                        disabled: true,
                                        value: detail?.payment_date,
                                    },
                                },
                                {
                                    seq: 2,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        heading: "เวลาชำระเงิน",
                                        onChange: (e) => { },
                                        type: 'time',
                                        disabled: true,
                                        value: timeToView(detail?.payment_date),
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 1.5
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "สกุลเงิน",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                        },
                                        options: [
                                            {
                                                label: "THB",
                                                value: "THB",
                                            },
                                            {
                                                label: "USD",
                                                value: 'USD',
                                            },

                                        ],
                                        selectId: "",
                                        disabled: true,
                                        value: detail?.payment_currency || '',
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        heading: "จำนวนยอดเงิน",
                                        onChange: (e) => { },
                                        disabled: true,
                                        value: detail?.payment_amount,
                                    }
                                },
                                {
                                    seq: 5,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 1.5
                                    },
                                    fieldProps: {
                                        heading: "ประเภทหลักฐาน",
                                        onChange: (e) => { },
                                        disabled: true,
                                        value: detail?.payment_type || 'ATTACH_SLIP',
                                    }
                                },
                            ]} />
                    </Box>
                } />
        </div>
    )
}
